export function paginationItems(current, total) {
  if (total <= 0) return [];
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const page = Math.max(1, Math.min(current, total));
  if (page <= 4) return [1, 2, 3, 4, 5, 'end-gap', total];
  if (page >= total - 3) return [1, 'start-gap', total - 4, total - 3, total - 2, total - 1, total];
  return [1, 'start-gap', page - 1, page, page + 1, 'end-gap', total];
}
